import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from './base-api.service';
import { FileSyncResultModel, FileSyncStatusModel } from '../models';

/**
 * Sync API Service
 */
@Injectable({
    providedIn: 'root'
})
export class SyncService extends BaseApiService {

    /**
     * Synchronize file
     */
    synchronizeFile(fileId: string): Observable<FileSyncResultModel> {
        return this.post<FileSyncResultModel>(`/sync/files/${fileId}`).pipe(
            map(response => response.data as FileSyncResultModel)
        );
    }

    /**
     * Synchronize project files
     */
    synchronizeProjectFiles(projectId: string): Observable<FileSyncResultModel> {
        return this.post<FileSyncResultModel>(`/sync/projects/${projectId}/files`).pipe(
            map(response => response.data as FileSyncResultModel)
        );
    }

    /**
     * Get file sync status
     */
    getFileSyncStatus(fileId: string): Observable<FileSyncStatusModel> {
        return this.get<FileSyncStatusModel>(`/sync/files/${fileId}/status`).pipe(
            map(response => response.data as FileSyncStatusModel)
        );
    }

    /**
     * Download synchronized file
     */
    downloadSynchronizedFile(fileId: string): Observable<Blob> {
        return this.getBlob(`/sync/files/${fileId}/download`);
    }
}



